const translations = {
    dronesBreakdown: '{{active}} active · {{grounded}} grounded',
    title: 'Maintenance',
    totalDrones: 'Total Drones'
};

export default translations;
